module.exports = __webpack_public_path__ + "img/logo-circle-gray.16ec0183.png";